import React from 'react'
import { Modal, ModalBody } from 'uiComponents/popups/modal.new'
import { OptionTile } from 'uiComponents/optionTile'
import { LucideIconName } from 'utils/lucideIcon'
import { UserRole } from 'settings/schema'
import { useTranslation } from 'translations'
import './chooseUserRoleModal.scss'

interface UserRoleDetails {
    title: string
    description: string
    icon: LucideIconName
}

interface ChooseUserRoleModalProps {
    options: UserRole[]
    onSelectUserRole: (userRole: UserRole) => void
    onDismiss: () => void
}

export const ChooseUserRoleModal = ({ options, onSelectUserRole, onDismiss }: ChooseUserRoleModalProps) => {
    const { t } = useTranslation()

    const useRoleDetails: Record<UserRole, UserRoleDetails> = {
        user: {
            title: t('settings.users.chooseRole.user.title'),
            description: t('settings.users.chooseRole.user.description'),
            icon: 'UserRound',
        },
        admin: {
            title: t('settings.users.chooseRole.admin.title'),
            description: t('settings.users.chooseRole.admin.description'),
            icon: 'ShieldUser',
        },
        reseller: {
            title: t('settings.users.chooseRole.reseller.title'),
            description: t('settings.users.chooseRole.reseller.description'),
            icon: 'Store',
        },
        staff: {
            title: t('settings.users.chooseRole.staff.title'),
            description: t('settings.users.chooseRole.staff.description'),
            icon: 'GlobeLock',
        },
    }

    return (
        <Modal title={t('settings.users.chooseRole.title')} className="choose-user-role-modal" onDismiss={onDismiss}>
            <ModalBody>
                {options.map((option) => (
                    <OptionTile
                        key={option}
                        title={useRoleDetails[option].title}
                        description={useRoleDetails[option].description}
                        icon={useRoleDetails[option].icon}
                        className={option}
                        onClick={() => onSelectUserRole(option)}
                    />
                ))}
            </ModalBody>
        </Modal>
    )
}
